import TextContent from "../TextContent";
import ResizableImageContent from "./ResizableImageContent";
import imgTextStyles from "./imgTextStyles.module.scss";

export default function ImageTextCard(props) {
  const { data } = props;

  return (
    <div className={imgTextStyles.maket}>
      <ResizableImageContent data={data} />
      <TextContent data={data} lefty />
    </div>
  );
}
